import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { format } from 'date-fns';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';
import { useAuth } from '../../hooks/useAuth';
import { REACTIVATE_CANCELLED_SUBSCRIPTION } from '../../mutations';

export default function ReactivateCancelledPlan({
  dispatchAction,
  currentPeriodEnd,
}) {
  const { getUser } = useAuth();

  const [reactivateCancelledSubscription, { loading, error, called, data }] =
    useMutation(REACTIVATE_CANCELLED_SUBSCRIPTION);

  useEffect(() => {
    if (reactivateCancelledSubscription) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () => reactivateCancelledSubscription(),
        },
      });
    }
  }, [dispatchAction, reactivateCancelledSubscription]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'Plan reactivated successfully.',
          nextAction: 'poll-subscription-status-for-not-cancelled',
        },
      });
    }
  }, [called, data, dispatchAction, error, getUser]);

  return (
    <div className="flex flex-col justify-center items center text-center space-y-4 w-full px-24">
      {loading && <LoadingSpinner message="Reactivating your plan..." />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <p>
            Reactivated your plan will take effect immediately and you will be
            billed as you normally would have at the end of your billing cycle
            on {format(new Date(Number(currentPeriodEnd)), 'PPP')}.
          </p>
          <p>To continue reactivating your plan, click continue.</p>
        </>
      )}
    </div>
  );
}
